import Modal from './modals';

const team = document.querySelector('#team');
const teamMembers = team.querySelectorAll('.team-member');

teamMembers.forEach(teamMember => {
  const modalEl = teamMember.querySelector('.modal');
  if (!modalEl) {
    return;
  }

  const modal = new Modal(modalEl);

  // Attach close actions
  ['.modal-bg-fade', '.btn.is-modal-close'].forEach(selector => {
    teamMember.querySelector(selector)?.addEventListener('click', () => {
      modal.close();
    });
  });

  // Attach open actions
  teamMember.querySelector('.modal-btn')?.addEventListener('click', () => {
    modal.open();
  });
});
